var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useMemo, useState } from "react";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import TrendingSearchBlock from "./Generic/TrendingSearchBlock";
import { RecentSearch } from "./RecentSearch";
import Errormsg from "@frameworks/web/components/generic/errorMsg";
import { SearchAssetTypeEnum, activeSectionOptions, dropDownCallPut, } from "./constant";
import searchDi from "@mainDi/features/Search/servicelocator";
import { Spinner } from "react-bootstrap";
import marginCalDi from "@frameworks/web/components/features/Tools/MarginCalculator/di/servicelocator";
import SearchDropdown from "./Generic/SearchDropdown";
import moment from "moment";
import _ from "underscore";
import { useLocation, useNavigate } from "react-router-dom";
import { GetStockElement } from "./AllSearchDataBlock";
import { useInView } from "react-intersection-observer";
import { getSearchStreamUpdate } from "@domains/features/Search/utils/SearchUtils";
import { useCustomSelector } from "@frameworks/shared-library/components/customHooks/customUseSector";
import { accountDetails } from "@mainDi/salesDi";
export var AssetTypeSwitch = function (type) {
    switch (type) {
        case SearchAssetTypeEnum.Equity:
            return "equities";
        case SearchAssetTypeEnum.Future:
            return "futures";
        case SearchAssetTypeEnum.Option:
            return "options";
        case SearchAssetTypeEnum.CurFut:
            return "currencies";
        case SearchAssetTypeEnum.CurOpt:
            return "currencies";
        case SearchAssetTypeEnum.ETFs:
            return "etfs";
        case SearchAssetTypeEnum.Indices:
            return "indicesList";
        case SearchAssetTypeEnum.NcdSecondary:
            return "ncdSecondaries";
        // case SearchAssetTypeEnum.SGB:
        //   return "sgbList";
        // case SearchAssetTypeEnum.CORPFD:
        //   return "corpFdList";
        case SearchAssetTypeEnum.PrimaryMarket:
            return "primaryMarket";
        case SearchAssetTypeEnum.ComFut:
            return "ComFut";
        case SearchAssetTypeEnum.ComOpt:
            return "ComOpt";
        case SearchAssetTypeEnum.MF:
            return "mutualFunds";
    }
};
var EquitySearchBlock = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var device = DeviceContext();
    var navigate = useNavigate();
    var state = useLocation().state;
    var _p = __read(useState(), 2), data = _p[0], setData = _p[1];
    var _q = __read(useState(false), 2), loader = _q[0], setLoader = _q[1];
    var _r = __read(useState([]), 2), strikePrice = _r[0], setStrikePrice = _r[1];
    var _s = __read(useState([]), 2), selectedStrikePrice = _s[0], setSelectedStrikePrice = _s[1];
    var _t = __read(useState([]), 2), selectOptionType = _t[0], setSelectedOptionType = _t[1];
    var _u = __read(React.useState([]), 2), inViewData = _u[0], setInviewData = _u[1];
    var _v = __read(React.useState(undefined), 2), initStream = _v[0], setInitStream = _v[1];
    var _w = __read(React.useState([]), 2), symbols = _w[0], setSymbols = _w[1];
    var _x = useInView(activeSectionOptions), ref = _x.ref, inView = _x.inView;
    var _y = __read(useState(), 2), empCode = _y[0], setEmpCode = _y[1];
    var accountCode = useCustomSelector(function (state) { return state.accountDetailsReducer; }, _.isEqual).accountCode;
    var trendingList = useMemo(function () {
        var _a, _b;
        if (((_a = props.trending) === null || _a === void 0 ? void 0 : _a.length) > 0)
            return (_b = props.trending) === null || _b === void 0 ? void 0 : _b.map(function (data, idx) {
                var _a;
                return (React.createElement(GetStockElement, { accountCode: accountCode || empCode, data: data, navigate: navigate, closePopup: props.closePopup, setShowToc: props === null || props === void 0 ? void 0 : props.setShowToc, edit: false, deleteSearch: function () { }, inViewCallBack: props.inViewCallBack, setInviewData: props.setInviewData, inViewData: props.inViewData, datalist: props.trending, keys: idx, setSearchedQuote: props.setSearchedQuote, placeOrder: (_a = state === null || state === void 0 ? void 0 : state.placeOrder) !== null && _a !== void 0 ? _a : props === null || props === void 0 ? void 0 : props.placeOrder }));
            });
        else
            return React.createElement(Errormsg, { icon: "", msg: "No results found", showIcon: false });
    }, [props.trending, empCode]);
    var getAssetTypeSearch = function (pageNumber) {
        setTimeout(function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
            setLoader(true);
            if (((_a = props.search) === null || _a === void 0 ? void 0 : _a.length) > 2) {
                var filter_1 = {
                    // searchText:
                    //   (props.type === SearchAssetTypeEnum.Option ||
                    //     props.type === SearchAssetTypeEnum.ComOpt ||
                    //     props.type === SearchAssetTypeEnum.CurOpt) &&
                    //   props?.selectedOption?.underlyingSymbolName
                    //     ? selectedStrikePrice?.length === 0 &&
                    //       props.selectedExpiry?.length === 0
                    //       ? props?.selectedOption?.underlyingSymbolName
                    //       : props.search
                    //     : props.search,
                    searchText: props.search,
                    underlyings: (_b = props === null || props === void 0 ? void 0 : props.selectedOption) === null || _b === void 0 ? void 0 : _b.underlyingSymbolName,
                    pageNumber: pageNumber ? pageNumber : 1,
                };
                switch (props.type) {
                    case SearchAssetTypeEnum.Equity:
                        if (!props.filters.list.every(function (x) { return x.selected; })) {
                            // if both is seleted so no need pass value
                            (_c = props.filters) === null || _c === void 0 ? void 0 : _c.list.map(function (x) {
                                if (x.selected) {
                                    filter_1.exchangeType = x.key;
                                }
                            });
                        }
                        break;
                    case SearchAssetTypeEnum.MF:
                        if (!props.filters.list.every(function (x) { return x.selected; })) {
                            {
                                var category_1 = [];
                                (_d = props.filters) === null || _d === void 0 ? void 0 : _d.list.map(function (x) {
                                    if (x.selected) {
                                        category_1.push(x.key);
                                    }
                                });
                                filter_1.category = category_1.join(",");
                            }
                        }
                        break;
                    case SearchAssetTypeEnum.Option:
                        if (((_e = props === null || props === void 0 ? void 0 : props.selectedExpiry) === null || _e === void 0 ? void 0 : _e.length) > 0)
                            filter_1.expiryDates = (_f = props === null || props === void 0 ? void 0 : props.selectedExpiry) === null || _f === void 0 ? void 0 : _f.join(",");
                        if ((selectedStrikePrice === null || selectedStrikePrice === void 0 ? void 0 : selectedStrikePrice.length) > 0)
                            filter_1.strikePrices = selectedStrikePrice === null || selectedStrikePrice === void 0 ? void 0 : selectedStrikePrice.join(",");
                        if ((selectOptionType === null || selectOptionType === void 0 ? void 0 : selectOptionType.length) > 0)
                            filter_1.optionTypes = selectOptionType === null || selectOptionType === void 0 ? void 0 : selectOptionType.join(",");
                        break;
                    case SearchAssetTypeEnum.CurOpt:
                        (_g = props.filters) === null || _g === void 0 ? void 0 : _g.list.map(function (x) {
                            if (x.selected) {
                                filter_1.category = x.key;
                            }
                        });
                        if (((_h = props === null || props === void 0 ? void 0 : props.selectedExpiry) === null || _h === void 0 ? void 0 : _h.length) > 0)
                            filter_1.expiryDates = (_j = props === null || props === void 0 ? void 0 : props.selectedExpiry) === null || _j === void 0 ? void 0 : _j.join(",");
                        if ((selectedStrikePrice === null || selectedStrikePrice === void 0 ? void 0 : selectedStrikePrice.length) > 0)
                            filter_1.strikePrices = selectedStrikePrice === null || selectedStrikePrice === void 0 ? void 0 : selectedStrikePrice.join(",");
                        if ((selectOptionType === null || selectOptionType === void 0 ? void 0 : selectOptionType.length) > 0)
                            filter_1.optionTypes = selectOptionType === null || selectOptionType === void 0 ? void 0 : selectOptionType.join(",");
                        break;
                    // case SearchAssetTypeEnum.CurFut:
                    //   props.filters?.list.map((x) => {
                    //     if (x.selected) {
                    //       filter.category = x.key as string;
                    //     }
                    //   });
                    case SearchAssetTypeEnum.ComOpt:
                        if (!props.filters.list.every(function (x) { return x.selected; })) {
                            (_k = props.filters) === null || _k === void 0 ? void 0 : _k.list.map(function (x) {
                                if (x.selected) {
                                    filter_1.exchangeType = x.key;
                                }
                            });
                        }
                        if (((_l = props === null || props === void 0 ? void 0 : props.selectedExpiry) === null || _l === void 0 ? void 0 : _l.length) > 0)
                            filter_1.expiryDates = (_m = props === null || props === void 0 ? void 0 : props.selectedExpiry) === null || _m === void 0 ? void 0 : _m.join(",");
                        if ((selectedStrikePrice === null || selectedStrikePrice === void 0 ? void 0 : selectedStrikePrice.length) > 0)
                            filter_1.strikePrices = selectedStrikePrice === null || selectedStrikePrice === void 0 ? void 0 : selectedStrikePrice.join(",");
                        if ((selectOptionType === null || selectOptionType === void 0 ? void 0 : selectOptionType.length) > 0)
                            filter_1.optionTypes = selectOptionType === null || selectOptionType === void 0 ? void 0 : selectOptionType.join(",");
                        break;
                    case SearchAssetTypeEnum.ComFut:
                        if (!props.filters.list.every(function (x) { return x.selected; }))
                            (_o = props.filters) === null || _o === void 0 ? void 0 : _o.list.map(function (x) {
                                if (x.selected) {
                                    filter_1.exchangeType = x.key;
                                }
                            });
                    case SearchAssetTypeEnum.PrimaryMarket:
                        if (!props.filters.list.every(function (x) { return x.selected; })) {
                            var marketType_1 = [];
                            (_p = props.filters) === null || _p === void 0 ? void 0 : _p.list.map(function (x) {
                                if (x.selected) {
                                    marketType_1.push(x.key);
                                }
                            });
                            filter_1.marketType = marketType_1.join(",");
                        }
                        break;
                    default:
                        break;
                }
                searchDi.search
                    .getAssetTypeSearch(props.type, filter_1)
                    .then(function (data) {
                    if (pageNumber) {
                        setData(function (da) {
                            var _a;
                            return __assign(__assign({}, data), (_a = {}, _a[AssetTypeSwitch(props.type)] = __spreadArray(__spreadArray([], __read(da[AssetTypeSwitch(props.type)]), false), __read(data[AssetTypeSwitch(props.type)]), false), _a));
                        });
                    }
                    else {
                        setData(data);
                    }
                })
                    .catch(function (error) { return console.log(error); })
                    .finally(function () {
                    setLoader(false);
                });
            }
        }, 500);
    };
    useEffect(function () {
        var _a;
        if (((_a = props === null || props === void 0 ? void 0 : props.expiryDates) === null || _a === void 0 ? void 0 : _a.length) > 0 ||
            (selectedStrikePrice === null || selectedStrikePrice === void 0 ? void 0 : selectedStrikePrice.length) > 0 ||
            (selectOptionType === null || selectOptionType === void 0 ? void 0 : selectOptionType.length) > 0)
            getAssetTypeSearch();
    }, [props === null || props === void 0 ? void 0 : props.selectedExpiry, selectedStrikePrice, selectOptionType]);
    useEffect(function () {
        var _a;
        var _b, _c, _d, _e, _f;
        if (((_b = props === null || props === void 0 ? void 0 : props.data) === null || _b === void 0 ? void 0 : _b.data) && (data === null || data === void 0 ? void 0 : data.previousPage) !== 0)
            setData((_a = {},
                _a[AssetTypeSwitch(props.type)] = (_c = props === null || props === void 0 ? void 0 : props.data) === null || _c === void 0 ? void 0 : _c.data,
                _a.nextPage = (_d = props.data) === null || _d === void 0 ? void 0 : _d.nextPage,
                _a.last = (_e = props.data) === null || _e === void 0 ? void 0 : _e.last,
                _a.previousPage = (_f = props.data) === null || _f === void 0 ? void 0 : _f.previousPage,
                _a));
        else
            getAssetTypeSearch();
    }, [(_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.data, JSON.stringify((_b = props.filters) === null || _b === void 0 ? void 0 : _b.list)]);
    var handleScroll = function (e) {
        var bottom = Math.abs(e.currentTarget.scrollHeight -
            (e.currentTarget.scrollTop + e.currentTarget.clientHeight)) <= 2;
        var load = loader;
        var nextPage = data === null || data === void 0 ? void 0 : data.nextPage;
        var last = data === null || data === void 0 ? void 0 : data.last;
        setData(function (da) {
            nextPage = da === null || da === void 0 ? void 0 : da.nextPage;
            last = da === null || da === void 0 ? void 0 : da.last;
            return da;
        });
        setLoader(function (D) {
            load = D;
            return D;
        });
        if (bottom &&
            data &&
            !last &&
            !load &&
            nextPage &&
            props.search.length > 2) {
            getAssetTypeSearch(nextPage);
        }
    };
    React.useEffect(function () {
        var modal;
        if (device === null || device === void 0 ? void 0 : device.isDesktop) {
            modal = document.getElementsByClassName("modal-body");
        }
        else {
            modal = document.getElementsByClassName("search-search-bar-mobile");
        }
        if (modal && modal.length > 0) {
            modal[0].addEventListener("scroll", handleScroll);
        }
        return function () {
            if (modal && modal.length > 0) {
                modal[0].removeEventListener("scroll", handleScroll);
            }
        };
    }, [loader, props.type, device]);
    var getStrikePriceList = function (expDate) {
        var req = {
            und: props.selectedOption.underlyingSymbolName,
            ins: props.selectedOption.instrumentType,
            optionType: "CE",
            exchange: props.selectedOption.exchange,
        };
        setStrikePrice([]);
        expDate.map(function (ex) {
            req.date = moment(ex).format("YYYY-MM-DD");
            marginCalDi.marginCalculator.getStrikePriceList(req).then(function (data) {
                var _a;
                if (((_a = data.strikePriceList) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    setStrikePrice(function (c) {
                        return _.uniq(__spreadArray(__spreadArray([], __read(c), false), __read(data.strikePriceList.map(function (x) {
                            return {
                                display: x,
                                value: x,
                            };
                        })), false), "value");
                    });
                }
            });
        });
    };
    var optionsFilters = useMemo(function () {
        return (props.type === SearchAssetTypeEnum.Option ||
            props.type === SearchAssetTypeEnum.ComOpt ||
            props.type === SearchAssetTypeEnum.CurOpt);
    }, [props.type]);
    var callStream = function (view) {
        setSymbols(function (prev) {
            searchDi.search.getSearchedStreamData(view, prev, function (mappedData) {
                var _a, _b;
                ((_a = data[AssetTypeSwitch(props.type)]) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                    ((_b = getSearchStreamUpdate(data[AssetTypeSwitch(props.type)], mappedData)) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
                    setData(function (prev) {
                        var _a;
                        var list = __assign(__assign({}, prev), (_a = {}, _a[AssetTypeSwitch(props.type)] = getSearchStreamUpdate(prev[AssetTypeSwitch(props.type)], mappedData), _a));
                        return list;
                    });
            });
            return prev;
        });
    };
    useEffect(function () {
        if (inView) {
            setInitStream(true);
        }
        if (!loader && !!initStream && (symbols === null || symbols === void 0 ? void 0 : symbols.length) > 0) {
            callStream(inView);
        }
    }, [inView, loader, initStream, symbols]);
    useEffect(function () {
        accountDetails.getSalesEmployeeCode().then(function (data) {
            if (data) {
                setEmpCode(data);
            }
        });
        return function () {
            callStream(false);
        };
    }, []);
    return (React.createElement(React.Fragment, null, ((_c = props.search) === null || _c === void 0 ? void 0 : _c.length) > 2 ? (React.createElement("div", { className: "equity-search-block  ".concat((device === null || device === void 0 ? void 0 : device.isDesktop) ? "pdt-30" : "pdlr-15 pdt-20") },
        optionsFilters && (React.createElement("div", { className: "pb-4 d-flex  ".concat((device === null || device === void 0 ? void 0 : device.isDesktop) ? "gap-12" : "gap-5-custom") },
            ((_d = props === null || props === void 0 ? void 0 : props.expiryDates) === null || _d === void 0 ? void 0 : _d.length) > 0 && (React.createElement("div", { className: "select-expiry-dropdown" },
                React.createElement(SearchDropdown, { list: props === null || props === void 0 ? void 0 : props.expiryDates, name: "expiry", selected: props === null || props === void 0 ? void 0 : props.selectedExpiry, onChange: function (e) {
                        props === null || props === void 0 ? void 0 : props.setSelectedExpiry([e.target.value]);
                        getStrikePriceList([e.target.value]);
                        // props?.setSelectedExpiry((ex: string[]) => {
                        //   let exp = [...ex];
                        //   const index = exp?.findIndex((z) => z === e.target.value);
                        //   if (e.target.checked && index === -1) {
                        //     exp.push(e.target.value);
                        //   } else {
                        //     exp.splice(index, 1);
                        //   }
                        //   getStrikePriceList(exp);
                        //   return exp;
                        // });
                    }, className: "select-expiry-dropdown", title: ((_e = props === null || props === void 0 ? void 0 : props.selectedExpiry) === null || _e === void 0 ? void 0 : _e.length) > 0
                        ? props === null || props === void 0 ? void 0 : props.selectedExpiry[0]
                        : "Select Expiry" }))),
            ((_f = props === null || props === void 0 ? void 0 : props.expiryDates) === null || _f === void 0 ? void 0 : _f.length) > 0 && (strikePrice === null || strikePrice === void 0 ? void 0 : strikePrice.length) > 0 && (React.createElement(SearchDropdown, { disabled: ((_g = props === null || props === void 0 ? void 0 : props.selectedExpiry) === null || _g === void 0 ? void 0 : _g.length) === 0, list: strikePrice.sort(function (a, b) { return +a.value - +b.value; }), name: "strikeprice", selected: selectedStrikePrice, onChange: function (e) {
                    setSelectedStrikePrice([e.target.value]);
                    // setSelectedStrikePrice((sp: string[]) => {
                    //   let strike = [...sp];
                    //   const index = strike?.findIndex(
                    //     (z) => z === e.target.value
                    //   );
                    //   if (e.target.checked && index === -1) {
                    //     strike.push(e.target.value);
                    //   } else {
                    //     strike.splice(index, 1);
                    //   }
                    //   return strike;
                    // });
                }, title: (selectedStrikePrice === null || selectedStrikePrice === void 0 ? void 0 : selectedStrikePrice.length) > 0
                    ? selectedStrikePrice[0]
                    : "Select Strike Price" })),
            React.createElement(SearchDropdown, { list: dropDownCallPut, name: "optiontype", selected: selectOptionType, onChange: function (e) {
                    setSelectedOptionType([e.target.value]);
                    // setSelectedOptionType((opType: string[]) => {
                    //   let type = [...opType];
                    //   const index = type?.findIndex((z) => z === e.target.value);
                    //   if (e.target.checked && index === -1) {
                    //     type.push(e.target.value);
                    //   } else {
                    //     type.splice(index, 1);
                    //   }
                    //   return type;
                    // });
                }, title: (selectOptionType === null || selectOptionType === void 0 ? void 0 : selectOptionType.length) > 0
                    ? dropDownCallPut.filter(function (x) { return x.value === selectOptionType[0]; })[0].display
                    : "Select Option Type" }))),
        React.createElement("div", { className: "searchdata-border-block " }, data && ((_h = data[AssetTypeSwitch(props.type)]) === null || _h === void 0 ? void 0 : _h.length) > 0 ? (React.createElement("div", { ref: ref }, (_j = data[AssetTypeSwitch(props.type)]) === null || _j === void 0 ? void 0 :
            _j.map(function (item, idx) {
                var _a, _b, _c;
                if (props.type === SearchAssetTypeEnum.Option) {
                    item = __assign(__assign({}, item), { idx: (_a = props === null || props === void 0 ? void 0 : props.selectedOption) === null || _a === void 0 ? void 0 : _a.idx, instrumentType: (_b = props.selectedOption) === null || _b === void 0 ? void 0 : _b.instrumentType });
                }
                return (React.createElement(GetStockElement, { placeOrder: (_c = state === null || state === void 0 ? void 0 : state.placeOrder) !== null && _c !== void 0 ? _c : props === null || props === void 0 ? void 0 : props.placeOrder, accountCode: accountCode || empCode, data: item, navigate: navigate, closePopup: props.closePopup, setShowToc: props === null || props === void 0 ? void 0 : props.setShowToc, edit: false, deleteSearch: function () { }, 
                    // inViewCallBack={props.inViewCallBack}
                    // setInviewData={props.setInviewData}
                    // inViewData={props.inViewData}
                    inViewCallBack: {
                        key: props.type === SearchAssetTypeEnum.ETFs
                            ? "quoteSymbol"
                            : props.type === SearchAssetTypeEnum.NcdSecondary
                                ? "ncdSymbol"
                                : "symbol",
                        callback: function (list) {
                            setSymbols(function (oldSymbol) {
                                if (oldSymbol.length > 0)
                                    callStream(false);
                                return oldSymbol;
                            });
                            setSymbols(JSON.parse(JSON.stringify(list)));
                        },
                    }, setInviewData: setInviewData, inViewData: inViewData, datalist: data[AssetTypeSwitch(props.type)], keys: idx, setSearchedQuote: props.setSearchedQuote }));
            }),
            loader && (React.createElement("div", { className: "d-flex align-item-center justify-content-center" },
                React.createElement(Spinner, { animation: "border", role: "status" },
                    React.createElement("span", { className: "visually-hidden" }, "Loading...")))))) : loader ? (React.createElement("div", { className: "d-flex align-item-center justify-content-center" },
            React.createElement(Spinner, { animation: "border", role: "status" },
                React.createElement("span", { className: "visually-hidden" }, "Loading...")))) : (data &&
            ((_k = data[AssetTypeSwitch(props.type)]) === null || _k === void 0 ? void 0 : _k.length) === 0 && (React.createElement(Errormsg, { icon: "", msg: "No results found", showIcon: false })))))) : (React.createElement(React.Fragment, null,
        ((_l = props.trending) === null || _l === void 0 ? void 0 : _l.length) > 0 && (React.createElement(TrendingSearchBlock, { content: trendingList })),
        ((_m = props.recentSearch) === null || _m === void 0 ? void 0 : _m.length) > 0 && (React.createElement(RecentSearch, { type: props.recentType, list: props.recentSearch, closePopup: props.closePopup, setShowToc: props === null || props === void 0 ? void 0 : props.setShowToc, setList: props === null || props === void 0 ? void 0 : props.setRecentSearch, inViewCallBack: props.inViewCallBack, setInviewData: props.setInviewData, inViewData: props.inViewData, setSearchedQuote: props.setSearchedQuote, placeOrder: (_o = state === null || state === void 0 ? void 0 : state.placeOrder) !== null && _o !== void 0 ? _o : props === null || props === void 0 ? void 0 : props.placeOrder, accountCode: accountCode || empCode }))))));
};
export default EquitySearchBlock;
